<template>
  <sx-flex
    :is-wrapping="true"
    :is-full-width="!!isFullWidth"
    :x-align="xAlign"
    :gap="isJoined ? 0 : 8"
    :class="isJoined && 'button-group--joined'"
    class="button-group"
  >
    <slot />
  </sx-flex>
</template>

<script>
import SxFlex from './SxFlex';

export default {
  components: {
    SxFlex,
  },
  props: {
    isFullWidth: {
      type: Boolean,
      default: false,
      required: false,
    },
    isJoined: {
      type: Boolean,
      default: false,
      required: false,
    },
    xAlign: {
      type: String, // left, right or center, default is left
      required: false,
    },
  },
};
</script>

<style scoped>
.button-group {
  /* NOTE @chris There is a flex overwrite bleeding from vuetify */
  flex-grow: 0 !important;
  flex-shrink: 1 !important;
}
</style>
